import { BasicClient } from '@/utils/httpClient'
export default class Manager {
  client
  constructor() {
    this.client = new BasicClient()
  }

  getMyTeam() {
    return this.client.exec('/manager/myteam', 'GET')
  }

  getStatistics() {
    return this.client.exec('/manager/myteam/statistics', 'GET')
  }
 
  getTeamUsers(value) {
    return this.client.exec(`/manager/myteam/search`, 'GET', {
      filter: value
    })
  }
  postManagerLicence(dateFrom,dateTo,licenseTypeId,userId,anticipatePayment) {
    const requestBody = { dateFrom, dateTo, licenseTypeId, userId };
  if (anticipatePayment === 1) {
    requestBody.anticipatePayment = 1;
  }
  return this.client.exec('/manager/myteam/licenses ', 'POST',  requestBody);
  }

  getLicenceTypes(userId) {
    return this.client.exec(`/manager/myteam/licensesTypes`, 'GET', {userId})
  }

  getEmployeeInfo(userId) {
    return this.client.exec(`/manager/myteam/users/${userId}`, 'GET')
  }

  getLicenceHolidays(idEmployee) {
    return this.client.exec(`/manager/myteam/licensesHolidays?idEmployee=${idEmployee}`, 'GET');
  }
  allowsSalaryPaymentAdvance(licenceId) {
    return this.client.exec(`/externalapis/sichernpeople/absences-type/${licenceId}`, 'GET')
  }
  getPendingTasks() {
    return this.client.exec('/manager/taskspending', 'GET')
  }
  getTaskDetails(id,type) {
    return this.client.exec(`/manager/tasksdetails`, 'GET', {'id':id , 'type':type})
  }

  getTotalPendingTasks() {
    return this.client.exec('/manager/tasklist/inbox', 'GET')
  }
}
